module.exports = __webpack_public_path__ + "media/images/buddy_spido-2fbca23d3ae77cebd8481eef9542677e.png";